import { Inject, Injectable, Optional } from '@angular/core';
import { ReducerManager, Store } from '@ngrx/store';
import { HttpParamsObject } from '../../services/api/api.service';
import { FhirApiService } from '../../services/api/fhir-api.sevice';
import { UserService } from '../../services/user.service';
import { OrganizationAdapter } from './organization.model';
import { OrganizationsService } from './organizations.service';

@Injectable({ providedIn: 'root' })
export class FacilitiesService extends OrganizationsService {
  get defaultParamsObject(): HttpParamsObject {
    return window.location.href.includes('reconciliation')
      ? {
          type: 'O1',
          active: true,
        }
      : {
          'subject-group': this.partnerCode,
          active: true,
        };
  }

  constructor(
    @Inject('dataName') @Optional() dataName: string,
    protected adapter: OrganizationAdapter,
    protected fhirApi: FhirApiService,
    protected userService: UserService,
    protected store: Store,
    protected manager: ReducerManager,
  ) {
    super(
      dataName || 'facility-organizations',
      adapter,
      fhirApi,
      userService,
      store,
      manager,
    );
  }
}
